module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp-brk1",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Everyone, I suppose, has shadows which pass before them at times like “ships that pass in the night.” To me one of the darkest of these shadows is that of the late Emperor of Russia and those who belonged to him. The sunbeams that light them up are the unfailing kindness which he always showed me in times of personal or other trouble, his sunny and cheerful nature, and his unfailing courage when things seemed to be going badly.")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("—Sir John Hanbury-Williams, Head of the British Military Mission at the Russian Army GHQ in World War I")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6efe7073","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0